export default "__VITE_ASSET__DcaqwacP__"